import { type ReactNode, useMemo } from 'react';

import { useParams } from '@remix-run/react';
import type { TPostElement } from '@shared/dream-components';

import Post from './Post';

interface Props {
  node: TPostElement;
  children: ReactNode | ReactNode[];
}

const PostContainer = ({ node, children }: Props) => {
  const { id, postGroupType, postsCategory } = node.attrs;
  const isTagPage = postGroupType === 'tag_page';
  const isAuthorPage = postGroupType === 'author_page';
  const isRecommendationsBlock = postGroupType === 'recommendations';
  const { tag, slug, authorId } = useParams();

  const componentKey = useMemo(() => {
    if (isRecommendationsBlock) {
      return `${id}-recommendations-${slug}`;
    }

    if (isTagPage && tag) {
      return `${id}-tag-${tag}`;
    }

    if (isAuthorPage && authorId) {
      return `${id}-author-${authorId}`;
    }

    return `${id}-${postsCategory ?? 'default'}`;
  }, [id, isRecommendationsBlock, isTagPage, isAuthorPage, slug, tag, authorId, postsCategory]);

  return (
    <Post key={componentKey} node={node}>
      {children}
    </Post>
  );
};

export default PostContainer;
